import React, { useState, useEffect } from 'react';
import { MessageCircle, ArrowUp } from 'lucide-react';
import styles from './FloatingButtons.module.css';

const FloatingButtons = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);

  // Check if scrolled down
  const handleScroll = () => {
    if (window.scrollY > 300) {
      setShowBackToTop(true);
    } else {
      setShowBackToTop(false);
    }
  };

  // Scroll back to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.floatingButtonsContainer}>
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/917533928185?text=Hello%20Ananta%20AI%20Anchors!%20I%20have%20a%20query%20about%20your%20services."
        target="_blank"
        rel="noopener noreferrer"
        className={styles.whatsappButton}
        title="Chat with us on WhatsApp"
      >
        <MessageCircle size={28} strokeWidth={1.5} />
      </a>

      {/* Back to Top Button */}
      {showBackToTop && (
        <button
          onClick={scrollToTop}
          className={styles.backToTopButton}
          title="Back to top"
        >
          <ArrowUp size={28} strokeWidth={1.5} />
        </button>
      )}
    </div>
  );
};

export default FloatingButtons;
